import { ActivityIndicator, View } from "react-native"
import { useLocalSearchParams } from "expo-router"

import { trpc } from "@src/utils"
import { Text, Header } from "@src/components"
import { CustomerForm } from "@src/components/customer-form"
import { ar } from "@src/i18n/ar"

export default function EditCustomer() {
  const params = useLocalSearchParams<{ id: string }>()
  const id = Number.parseInt(params.id, 10)
  const customer = trpc.customers.get.useQuery({ id })

  if (customer.isLoading) {
    return (
      <>
        <Header title={ar.editCustomer} />
        <ActivityIndicator className="mt-4" />
      </>
    )
  }

  if (!customer.data) {
    return (
      <>
        <Header title={ar.editCustomer} />
        <View className="flex-1 justify-center items-center">
          <Text>Customer not found</Text>
        </View>
      </>
    )
  }

  return (
    <>
      <Header title={ar.editCustomer} />
      <CustomerForm id={id} />
    </>
  )
}
